export default __webpack_public_path__ + "static/cloud-native-identity-97903c5558239663ae05b3c6af1dc7e5.webp";